module.exports = __webpack_public_path__ + "static/media/information-at-glance.9dd8f677.png";